module.exports = __webpack_public_path__ + "static/media/face_verification_demo.c309b448.png";